<template lang="html">
    <section class="waotp">
        <div>
            <div class="Vlt-grid">
                <div class="Vlt-col Vlt-col--A-2of4">
                    <vlt-field style="display: inline-block;" :label="t('WhatsApp Number') + ':'">
                        <vue-phone-number-input :translations="lang ? lang.phonetranslation : null" color="#131415"
                            :no-validator-state="false" :default-country-code="nexmo.region" v-model="prettyNumber"
                            @update="onUpdate" />
                    </vlt-field>
                    &nbsp;
                    <vlt-field style="display: inline-block;width:280px;margin-bottom:-10px"
                        :label="t('Email Address') + ':'">
                        <vlt-input style="top:-7px;margin-top:10px" v-model="email" :val="email" />
                    </vlt-field>
                </div>
                <div class="Vlt-col Vlt-col--A-1of4">
                    <vlt-field :label="t('Brand') + ' :'">
                        <vlt-input v-model="brand" :val="brand" />
                    </vlt-field>
                </div>
                <div class="Vlt-col Vlt-col--A-1of4">
                    <vlt-field :label="t('Timeout') + ' :'">
                        <div class="Vlt-native-dropdown">
                            <select v-model="timeout">
                                <option value='60'>{{ t('1 Minute') }}</option>
                                <option value='180'>{{ t('3 Minutes') }}</option>
                                <option value='300'>{{ t('5 Minutes') }}</option>
                                <option value='900'>{{ t('Seemingly forever, but really 15 minutes') }}</option>
                            </select>
                        </div>
                    </vlt-field>
                </div>
            </div>
            <br>
            <div class="Vlt-tabs">
                <div class="Vlt-tabs__header Vlt-tabs__header--bordered Vlt-margin--bottom4">
                    <li class="Vlt-tabs__link" v-bind:class="{ 'Vlt-tabs__link_active': tab == 1 }"
                        v-on:click="tab = 1">
                        {{ t('Verify V2: Interactive') }}</li>
                    <li class="Vlt-tabs__link" v-bind:class="{ 'Vlt-tabs__link_active': tab == 2 }"
                        v-on:click="tab = 2">
                        {{ t('Validation and Conversation') }}</li>
                    <li class="Vlt-tabs__link" v-bind:class="{ 'Vlt-tabs__link_active': tab == 3 }"
                        v-on:click="tab = 3">
                        {{ t('QR Code Response') }}</li>
                    <li class="Vlt-tabs__link" v-bind:class="{ 'Vlt-tabs__link_active': tab == 4 }"
                        v-on:click="tab = 4">
                        {{ t('Voice Biometrics (VeriMetrics)') }}</li>
                </div>
                <div class="Vlt-tabs__content">
                    <div v-show="tab == 1">
                        <div class="Vlt-grid">
                            <div class="Vlt-col Vlt-col--A-1of3">
                                <div style="font-size:12px" class="Vlt-card">
                                    <h3>{{ t('Verify V2: Interactive') }}
                                    </h3>
                                    <div class="Vlt-native-dropdown  Vlt-native-dropdown--app"
                                        style="margin-bottom:30px;margin-left:30px">
                                        <h4 style="margin-right:10px;color:blue">First, try:</h4>
                                        <select v-model="choice[0]" :val="methods[0].channel" @change="newSelection(0)">
                                            <option v-for="(method, index) in methods" :value="index" v-if="index > 0">
                                                {{
                        method.name }}</option>
                                        </select>
                                    </div>
                                    <div class="Vlt-native-dropdown  Vlt-native-dropdown--app"
                                        style="margin-bottom:30px;margin-left:30px">
                                        <h4 style="margin-right:10px;color:blue">Then try:</h4>
                                        <select v-model="choice[1]" :val="methods[1].channel" @change="newSelection(1)">
                                            <option v-for="(method, index) in methods" :value="index">{{ method.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="Vlt-native-dropdown  Vlt-native-dropdown--app"
                                        style="margin-bottom:30px;margin-left:30px">
                                        <h4 style="margin-right:10px;color:blue">Then try:</h4>
                                        <select v-model="choice[2]" :val="methods[2].channel" @change="newSelection(2)">
                                            <option v-for="(method, index) in methods" :value="index">{{ method.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div style="margin-left:120px">
                                        <vlt-button quaternary app :label="t('Request Verification')"
                                            @click="doIt('v2')" />
                                    </div>
                                    <div v-if="1 || showCode" style="margin-bottom:30px;margin-left:30px">
                                        <vlt-field style="height:65px;" :label="t('Verification Code') + ':'">
                                            <vlt-input style="display: inline-block;margin-right: 20px;width:80px;"
                                                v-model="code" :val="code" />
                                            <vlt-button :disabled="!code" style="display: inline-block;" quaternary app
                                                :label="t('Send')" @click="sendCode" />
                                        </vlt-field>
                                    </div>
                                </div>
                            </div>
                            <div class="Vlt-col Vlt-col--A-1of2">
                                <div class="Vlt-table Vlt-table--short" data-sortable style="padding-bottom: 1px;"
                                    height="400px">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Time</th>
                                                <th>Message</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in v2">
                                                <td>{{ item.timestamp }}</td>
                                                <td>{{ item.message }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="tab == 2">
                        <div class="Vlt-grid">
                            <div class="Vlt-col Vlt-col--A-1of3">
                                <div style="font-size:12px" class="Vlt-card Vlt-card--scrollable ">
                                    <h3>{{ t('Validation and Conversation') }}</h3>
                                    <vlt-field v-if="false" :label="t('Initial Message') + ' :'">
                                        <vlt-input textarea :rows="3" v-model="msg.initial" :val="msg.initial" />
                                    </vlt-field>
                                    <vlt-field :label="t('Followup Message on Success') + ' :'">
                                        <vlt-input textarea :rows="3" v-model="msg.success" :val="msg.success" />
                                    </vlt-field>
                                    <vlt-field :label="t('Followup Message on Rejection') + ' :'">
                                        <vlt-input textarea :rows="3" v-model="msg.reject" :val="msg.reject" />
                                    </vlt-field>
                                    <div style="height:50px;">
                                        <vlt-button quaternary app :label="t('Request Verification')"
                                            @click="doIt('button')" />
                                    </div>
                                </div>
                            </div>
                            <div class="Vlt-col Vlt-col--A-1of2">
                                <div class="Vlt-table Vlt-table--short" data-sortable style="padding-bottom: 1px;"
                                    height="400px">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Time</th>
                                                <th>Message</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in button">
                                                <td>{{ item.timestamp }}</td>
                                                <td>{{ item.message }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="tab == 3">
                        <div class="Vlt-grid">
                            <div class="Vlt-col Vlt-col--A-1of3">
                                <div style="font-size:12px" class="Vlt-card Vlt-card--scrollable ">
                                    <h3>{{ t('QR Code Response') }}</h3>
                                    <div style="height:50px;">
                                        <vlt-button quaternary app :label="t('Request Verification')"
                                            @click="doIt('qr')" />
                                    </div>
                                    <div v-if="doqr">
                                        <br>
                                        <h4> Scan this QR code with your phone for verification</h4>
                                        <qrcode style="margin-left:100px;" :value="qrtext" :options="{ width: 150 }">
                                        </qrcode>
                                    </div>
                                </div>
                            </div>
                            <div class="Vlt-col Vlt-col--A-1of2">
                                <div class="Vlt-table Vlt-table--short" data-sortable style="padding-bottom: 1px;"
                                    height="400px">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Time</th>
                                                <th>Message</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in qr">
                                                <td>{{ item.timestamp }}</td>
                                                <td>{{ item.message }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="tab == 4">
                        <div class="Vlt-grid">
                            <div class="Vlt-col Vlt-col--A-1of3">
                                <div style="font-size:12px;height:270px" class="Vlt-card Vlt-card--scrollable ">
                                    <h3>{{ t('Voice Biometrics (VeriMetrics)') }}</h3>
                                    <div style="height:50px;">
                                        <vlt-button :disabled='registered' quaternary app :label="t('Register Voice')"
                                            @click="enroll" /><br>
                                        <vlt-button :disabled='!registered' quaternary app
                                            :label="t('Request Verification')" @click="doIt('biometrics')" /><br>
                                        <vlt-button :disabled='!registered' quaternary app
                                            :label="t('Delete Registration')" @click="deletion" />
                                    </div>
                                </div>
                            </div>
                            <div class="Vlt-col Vlt-col--A-1of2">
                                <div class="Vlt-table Vlt-table--short" data-sortable style="padding-bottom: 1px;"
                                    height="400px">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Time</th>
                                                <th>Message</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in biometrics">
                                                <td>{{ item.timestamp }}</td>
                                                <td>{{ item.message }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br><br>
            <div v-if="true" class="Vlt-grid">
                <div class="Vlt-col Vlt-col--A-1of3">
                </div>
                <div class="Vlt-col Vlt-col--A-1of3">
                    <reportsAPI :nexmo="nexmo" reportType="MESSAGES" tmpId="9999" :lang="lang" :baseLang="baseLang" />
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="js">
import axios from 'axios';
import {
    $HTTPDEMO,
    requestHandler
} from '../services/nidsService.js';
import {
    $NODEBASE
} from '../base';
import Pusher from "pusher-js";
import {
    parsePhoneNumberFromString
} from 'libphonenumber-js';
import {
    JSONView
} from "vue-json-component";
import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,
    VltModal,
    VltCheckbox,
} from "@vonagevolta/vue";
import reportsAPI from "@/components/reportsAPI";
import {
    timeout
} from 'q';
import VueQrcode from "@chenfengyuan/vue-qrcode";

export default {
    name: 'sampleDemo',
    data() {
        return {
            postscript: "waverify",
            tab: 1,
            number: '',
            prettyNumber: '',
            numberStuff: {},
            fromNumber: '',
            isValid: true,
            NODEDEMO: {},
            pusher: {},
            v2: [],
            button: [],
            qr: [],
            biometrics: [],
            brand: 'VIDS',
            timeout: 60,
            msg: {
                initial: "Select Yes to validate, No to reject",
                success: "You have accepted the validation!  Now, let's talk... type something to continue the conversation in this channel.",
                reject: "You have rejected the validation. Please respond here if there is an issue."
            },
            doqr: false,
            pin: '00000000',
            qrtext: '',
            registered: false,
            VERI: {},
            uuid: null,
            language: 'en',
            email: this.nexmo.email,
            code: "",
            showCode: false,
            choice: [2, 3, 5],
            methods: [{
                channel: 'none',
                name: 'Nothing',
                use: true,
            },
            {
                channel: 'silent_auth',
                name: 'Silent Authorization',
                use: true,
            },
            /*                {
                                channel: 'whatsapp_interactive',
                                name: 'WhatsApp Interactive',
                                use: true,
                            },
                            */
            {
                channel: 'whatsapp',
                name: 'WhatsApp PIN',
                use: true,
            },

            {
                channel: 'sms',
                name: 'SMS',
                use: true,
            },
            {
                channel: 'voice',
                name: 'Voice PIN',
                use: true,
            },
            {
                channel: 'email',
                name: 'Email',
                use: true,
            }
            ],
            steps: [{
                channel: 'whatsapp',
                name: 'WhatsApp PIN',
                use: true,
            },
            {
                channel: 'sms',
                name: 'SMS',
                use: true,
            },
            {
                channel: 'email',
                name: 'Email',
                use: true,
            }
            ],
            keepalive: null,
            debugURL: '',//'https://neru-ef3346a6-debug-debug.use1.runtime.vonage.cloud',
            vUrl: 'https://vids.vonage.com/waverify',
        }
    },
    props: {
        nexmo: {
            type: Object,
            required: false
        },
        baseLang: {
            type: Object,
            required: false
        },
        lang: {
            type: Object,
            required: false
        },
        demoItem: {
            type: Object,
            required: false
        },
    },
    watch: {
        lang: function (newVal) {
            // Any strings that need to be dynamically changed on Language Change go here...
        }
    },
    methods: {
        newSelection(index) {
            //console.log("New Selection " + index, this.choice[index])
            if (this.choice[index] < 2) {
                this.showCode = false;
            }
            if (this.choice[index] == 1) { // Silent Auth
                this.$swal('Silent Auth',
                    'Note: This requires a demo application installed on your mobile phone. This app will be available soon.',
                    'warning');
            }
        },
        sendCode() {
            if (!this.code) return;
            let dt = new Date().toLocaleString();
            this.NODEDEMO.post('v2code', {
                code: this.code,
            }).then(request => {
                console.log("v2 code result for  " + this.number + ": ", request.data);
                this.v2.unshift({
                    timestamp: dt,
                    message: "Verification code response: " + request.data.reason
                })
                if (request.data.reason == 'Success') {
                    this.$swal('Verification Success',
                        "Your verification was successful",
                        'success');
                }
            })
        },
        doIt(flavor) {
            let dt = new Date().toLocaleString();
            switch (flavor) {
                case 'v2':
                    this.code = '';
                    console.log("Steps: ", this.steps);
                    let send = [];
                    this.choice.forEach((step) => {
                        if (step > 0) {
                            console.log("Pushing step: ", this.methods[step])
                            send.push(this.methods[step])
                        }
                    })
                    if (!send.length) {
                        console.log("Empty request, don't send");
                        this.$swal('Verify V2',
                            'You must choose at least one method for Verification.',
                            'warning');
                        return;
                    }
                    console.log("Request for V2: ", send);
                    this.NODEDEMO.post('v2', {
                        phone: this.number,
                        timeout: this.timeout,
                        brand: this.brand,
                        email: this.email,
                        steps: send,
                    }).then(request => {
                        console.log("v2 result for  " + this.number);
                        if (request.data.id) {
                            if ((this.choice[0] > 2)) {
                                this.showCode = true;
                            } else {
                                this.showCode = false;
                            }
                            this.v2.unshift({
                                timestamp: dt,
                                message: "Verification request to " + this.number + ": " + request.data.id
                            })
                        } else {
                            this.v2.unshift({
                                timestamp: dt,
                                message: "Verification request to " + this.number + " failed: " + request.data.reason
                            })
                            this.$swal('Verify V2 Request failed',
                                request.data.reason,
                                'warning');
                        }
                    }).catch(err => {
                        console.log("v2 request error: ", err)
                    })
                    break;
                case 'button':
                    this.NODEDEMO.post('button', {
                        phone: this.number,
                        initial: this.msg.initial,
                        success: this.msg.success,
                        reject: this.msg.reject,
                        brand: this.brand,
                        timeout: this.timeout,
                    }).then(request => {
                        console.log("v2 result for  " + this.number);
                        this.button.unshift({
                            timestamp: dt,
                            message: "Verification/Conversation request to " + this.number
                        })
                    })
                    break;
                case 'qr':
                    this.pin = "" + Math.floor(Math.random() * 89999999 + 10000000); // Random 8 digit number
                    this.qrtext = 'https://wa.me/447520645311?text=' + encodeURI('' + this.brand + ': Send this for verification. Code=' + this.pin)
                    console.log("QR: " + this.qrtext)
                    this.NODEDEMO.post('qr', {
                        phone: this.number,
                        pin: this.pin,
                        timeout: this.timeout,
                        brand: this.brand,
                    }).then(request => {
                        console.log("qr result for  " + this.number);
                        this.qr.unshift({
                            timestamp: dt,
                            message: "Verification QR created for " + this.number + ", PIN=" + this.pin
                        })
                    })
                    this.doqr = true;
                    break;
                case 'biometrics':
                    this.verify();
                    break;
                default:
                    break;
            }
        },
        info() {
            this.$swal({
                title: 'Verify V2 Fallbacks',
                text: 'When one verification method fails or times out, Verify V2 will fall back into the next verification method.',
                icon: 'success',
                position: 'center-start'
            });
        },
        async register() {
            console.log("Registering the Demo Component with the associated backend: ", new Date().toLocaleString());
            const results = await this.NODEDEMO.post('register', {});
            console.log("Back from Registering the Demo Component with the associated backend: ", new Date().toLocaleString(), results.data);
            if (this.demoItem.port) {
                this.keepalive = setInterval(() => {
                    this.NODEDEMO.get('keepalive?id=' + this.nexmo.userid);
                    console.log("Keptalive!")
                }, 60 * 1000);
            }
        },
        onUpdate(payload) {
            console.log(payload);
            this.numberStuff = payload;
            this.isValid = payload.isValid;
            if (payload.isValid) {
                this.cname = payload.countryCode == "US" ? true : false;
                this.number = this.numberStuff.formattedNumber.replace(/\D/g, '');;
                this.isenrolled(this.number);
            } else {
                var test = parsePhoneNumberFromString(payload.formattedNumber);
                console.log("Re-checked number: ", test)
                if (test.isValid()) {
                    this.isValid = true;
                    this.number = test.number.replace(/\D/g, '');
                    console.log("new this.number = ", this.number)
                    this.isenrolled(this.number);
                } else {
                    this.isValid = false;
                }
            }
        },
        check() {
            let params = {
                requestid: this.uuid,
            }
            console.log("Checking ", this.uuid);
            this.VERI.post('check', params).then(request => {
                console.log("Check request response: ", request.data);
            }).catch(error => {
                console.log("Check Error from verimetrics: ", error.response)
            });
        },
        isenrolled(phone) {
            let params = {
                phone: phone,
            }
            let aThis = this;
            this.VERI.post('isenrolled', params).then(request => {
                console.log("isEnrolled request response: ", request.data);
                if (request.data.result == 'success') {
                    console.log("Setting registered true")
                    this.registered = true;
                } else {
                    console.log("Setting registered false")
                    this.registered = false;
                }
            }).catch(error => {
                console.log("isEnrolled Error from verimetrics: ", error.response)
            });
        },
        deletion() {
            this.resp = '';
            let params = {
                phone: this.number,
            }
            console.log("doDelete ", this.number);
            let dt = new Date().toLocaleString();
            this.VERI.post('deleteenrollment', params).then(request => {
                console.log("doDelete request response: ", request.data);
                this.biometrics.unshift({
                    timestamp: dt,
                    message: "Voice Biometrics Registration deleted for " + this.number
                })
                this.isenrolled(this.number);
            }).catch(error => {
                console.log("doDelete Error from verimetrics: ", error.response)
                this.biometrics.unshift({
                    timestamp: dt,
                    message: "Voice Biometrics Deletion failed for " + this.number
                })
                this.isenrolled(this.number);
            });
        },
        enroll() {
            let dt = new Date().toLocaleString();
            let params = {
                phone: this.number,
                timeout: 180, // longer than default from pulldown
                language: this.language,
                channel: 'wa',
                url: this.vUrl + '/verimetrics?uid=' + this.nexmo.userid
            }
            console.log("Enrolling ", this.number);
            this.VERI.post('enroll', params).then(request => {
                console.log("Enroll request response: ", request.data);
                this.uuid = request.data.requestid;
                this.biometrics.unshift({
                    timestamp: dt,
                    message: "Voice Biometrics Registration request sent to " + this.number
                })
            }).catch(error => {
                console.log("Verify Error from verimetrics: ", error.response)
            });
        },
        verify() {
            let dt = new Date().toLocaleString();
            let params = {
                phone: this.number,
                timeout: this.timeout,
                language: this.language,
                channel: 'wa',
                url: this.vUrl + '/verimetrics?uid=' + this.nexmo.userid
            }
            console.log("Verifying ", this.number);
            this.VERI.post('verify', params).then(request => {
                console.log("Verify request response: ", request.data);
                this.uuid = request.data.requestid;
                this.biometrics.unshift({
                    timestamp: dt,
                    message: "Voice Biometrics Verification request sent to " + this.number
                })
            }).catch(error => {
                console.log("Verify Error from verimetrics: ", error.response, error.response.data.error)
                this.biometrics.unshift({
                    timestamp: dt,
                    message: "Voice Biometrics Verification error: " + error.response.data.error
                })
                this.$swal.fire({
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2500,
                    icon: 'warning',
                    html: '<h5>There is already a Verification pending for this number.</h5>',
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', this.$swal.stopTimer)
                        toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                    }
                })
            });
        },
        send(message) {
            let params = {
                requestid: this.uuid,
                message: message
            }
            console.log("Sendmessage: " + message);
            let dt = new Date().toLocaleString();
            this.VERI.post('sendmessage', params).then(request => {
                console.log("sendmessage request response: ", request.data);
                this.biometrics.unshift({
                    timestamp: dt,
                    message: "WA Message sent to " + this.number + ": " + message
                })
            }).catch(error => {
                console.log("sendmessage Error from verimetrics: ", error.response)
            });
        },
        doBio(obj) {
            let dt = new Date().toLocaleString();
            let msg;
            switch (obj.action) {
                case 'enroll':
                    this.isenrolled(obj.phone);
                    if (obj.biometrics == '1') {
                        msg = obj.phone + ' has been successfully registered using Voice Biometrics';
                        this.send(msg);
                        this.$swal('Voice Registration Success',
                            msg,
                            'success');
                    } else {
                        msg = obj.phone + ' was NOT registered using Voice Biometrics';
                        this.send(msg);
                        this.$swal('Voice Registration Failure',
                            msg,
                            'warning');
                    }
                    this.biometrics.unshift({
                        timestamp: dt,
                        message: msg
                    })
                    break;
                case 'verify':
                    if ((obj.biometrics == '1') && (obj.pinmatch == '1')) {
                        msg = obj.phone + ' has been successfully verified using Voice Biometrics';
                        this.send(msg);
                        this.$swal('Voice Verification Success',
                            msg,
                            'success');
                    } else if (obj.biometrics == '1') {
                        msg = obj.phone + ' provided the wrong PIN.';
                        this.send(msg + " You may try sending it again using the same PIN.");
                        this.$swal('Voice Verification Failure',
                            msg,
                            'warning');
                    } else if (obj.pinmatch == '1') {
                        msg = obj.phone + ' voice did not match';
                        this.send(msg + " You may try sending it again using the same PIN.");
                        this.$swal('Voice Verification Failure',
                            msg,
                            'warning');
                    } else {
                        msg = obj.phone + ' was NOT verified using Voice Biometrics';
                        this.send(msg);
                        this.$swal('Voice Verification Failure',
                            msg,
                            'warning');
                    }
                    this.biometrics.unshift({
                        timestamp: dt,
                        message: msg
                    })
                    break;
            }
        },
        t(key) { // T for Translate...
            return this.$tr(key, this.lang, this.baseLang)
        },
    },
    components: {
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput,
        "vlt-modal": VltModal,
        "vlt-checkbox": VltCheckbox,
        "json-view": JSONView,
        reportsAPI,
        qrcode: VueQrcode,
    },
    created() {
        // If the backend is a NODE server, use this...
        console.log("waverify demoItem: ", this.demoItem);
        if (this.debugURL && process.env.NODE_ENV === 'development') this.demoItem.port = this.debugURL;
        if (this.demoItem.port) { //VCR
            console.log("Wow, using the forced Debug URL instance!!!", this.demoItem.port)
            this.NODEDEMO = axios.create({
                baseURL: this.demoItem.port + '/',
                headers: {
                    "Content-Type": "application/json",
                },
            });
            this.vUrl = this.demoItem.port;
        } else if ($NODEBASE.indexOf("ngrok") > 0) {
            this.NODEDEMO = axios.create({
                baseURL: $NODEBASE + '/',
                headers: {
                    "Content-Type": "application/json",
                },
            });
        } else {
            this.NODEDEMO = axios.create({
                baseURL: $NODEBASE + '/' + this.postscript,
                headers: {
                    "Content-Type": "application/json",
                },
            });
        }
        this.NODEDEMO.interceptors.request.use(
            request => requestHandler(request)
        )
        this.VERI = axios.create({
            baseURL: 'https://vids.vonage.com/verimetrics/',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        this.VERI.interceptors.request.use(
            request => requestHandler(request)
        )
        this.fromNumber = parsePhoneNumberFromString("+" + this.nexmo['from']).formatInternational();
        this.prettyNumber = parsePhoneNumberFromString("+" + this.nexmo['phone']).formatNational();
        this.register();
        this.pusher = new Pusher(this.nexmo['pusher_key'], { //Pusher Key
            cluster: 'us3',
            forceTLS: true
        });
        let channel = this.pusher.subscribe(this.postscript);
        channel.bind(this.postscript + "_" + this.nexmo.userid, data => {
            console.log("Got some WA OTP data: " + JSON.stringify(data));
            let dt = new Date().toLocaleString();
            let queue = this.biometrics;
            switch (data.event) {
                case 'v2':
                    queue = this.v2;
                    break;
                case 'button':
                    queue = this.button;
                    break;
                case 'qr':
                    queue = this.qr;
                    break;
            }
            switch (data.event) {
                case 'v2':
                case 'button':
                case 'qr':
                    let msg = data.message;
                    if (!data.request) data.request = '';
                    if (data.type == 'text') {
                        queue.unshift({
                            timestamp: dt,
                            message: "The user typed: " + data.message
                        })
                    }
                    if (data.type == 'event' && data.status == 'expired') {
                        this.showCode = true;
                        msg = "Verification Step (" + data.channel + ") Expired, trying next method";
                        queue.unshift({
                            timestamp: dt,
                            message: msg
                        })
                        this.$swal('Verification Step Expired',
                            msg,
                            'warning');
                    }
                    if ((data.event == 'v2' && data.type == 'summary') || (data.type == 'event' && data.event != 'v2')) {
                        switch (data.status) {
                            case 'completed':
                            case 'verified':
                                msg = "Verification " + data.request + " validated successfully";
                                this.$swal('Verification Success',
                                    msg,
                                    'success');
                                break;
                            case 'user_rejected':
                                msg = "Verification " + data.request + " was rejected by the user";
                                this.$swal('Verification Rejected',
                                    msg,
                                    'warning');
                                break;
                            case 'expired':
                                msg = "Verification " + data.request + " expired";
                                this.$swal('Verification Expired',
                                    msg,
                                    'warning');
                                break;
                            case 'unexpected':
                                msg = "Verification came from an unexpected device";
                                this.$swal('Verification Failed',
                                    msg,
                                    'warning');
                                break;
                        }
                        queue.unshift({
                            timestamp: dt,
                            message: msg
                        })
                    }
                    break;
                case 'biometrics':
                    this.doBio(data.message);
                    break;
                default:
                    break;
            }
        })
    },
    beforeDestroy() {
        console.log("beforeDestroy for WA OTP demo")
        if (this.pusher) {
            this.pusher.unsubscribe(this.postscript);
        }
        if (this.keepalive) {
            clearInterval(this.keepalive);
            this.keepalive = null;
        }

    },
}
</script>

<style scoped lang="scss"></style>
